import { DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import thBEPicker from "../utils/locale/th_BE_picker"; // ที่ตั้ง yearFormat = 'BBBB'

dayjs.locale("th");
dayjs.extend(buddhistEra);

const toThaiDigits = (s) => s.replace(/\d/g, (d) => "๐๑๒๓๔๕๖๗๘๙"[d]);

function formatThaiBE(value, { thaiDigits = false, longMonth = false } = {}) {
  if (!value) return "";
  const d = value.locale("th");
  const dd = d.format("DD");
  const month = d.format(longMonth ? "MMMM" : "MMM"); // ก.พ. / กุมภาพันธ์
  const yearBE = d.year() + 543; // แสดงปี พ.ศ.
  let str = `${dd} ${month} ${yearBE}`;
  return thaiDigits ? toThaiDigits(str) : str;
}

export default function ThaiDatePicker({
  value,
  onChange,
  thaiDigits = false, // true = แปลงเลขเป็น ๐-๙
  longMonth = false, // true = ชื่อเดือนเต็ม
  inputReadOnly = true, // ป้องกันพิมพ์ค่า BE เองแล้ว parse เพี้ยน
  placeholder = "เลือกวันที่ (พ.ศ.)",
  ...props
}) {
  return (
    <DatePicker
      locale={thBEPicker} // ✅ ใส่ locale
      value={value}
      onChange={onChange}
      format={(v) => formatThaiBE(v, { thaiDigits, longMonth })}
      placeholder={placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      {...props}
    />
  );
}

export function ThaiRangePicker({
  value,
  onChange,
  thaiDigits = false,
  longMonth = false,
  inputReadOnly = true,
  placeholder = ["วันที่เริ่ม (พ.ศ.)", "วันที่สิ้นสุด (พ.ศ.)"],
  ...props
}) {
  const { RangePicker } = DatePicker;
  return (
    <RangePicker
      locale={thBEPicker} // ✅ ใส่ locale
      value={value}
      onChange={onChange}
      format={(v) => formatThaiBE(v, { thaiDigits, longMonth })}
      placeholder={placeholder}
      allowClear
      inputReadOnly={inputReadOnly}
      {...props}
    />
  );
}
